import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useCallback, useState, useEffect } from "react";

const SearchBar = ({ value, onChange, sortBy, onSortChange }) => {
  const [localValue, setLocalValue] = useState(value);

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      onChange(localValue);
    }, 200);
    return () => clearTimeout(timer);
  }, [localValue, onChange]);

  // Sync with external value
  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleClear = useCallback(() => {
    setLocalValue("");
    onChange("");
  }, [onChange]);

  return (
    <div className="flex flex-col sm:flex-row gap-4" data-testid="search-bar">
      <div className="relative flex-1">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
        <Input
          id="search-input"
          type="text"
          placeholder="Search by keyword, technology, market, or use case... (Press / to focus)"
          value={localValue}
          onChange={(e) => setLocalValue(e.target.value)}
          className="pl-12 pr-10 h-12 rounded-xl border-slate-200 bg-white text-base focus-visible:ring-[#FF6F40] focus-visible:ring-offset-0"
          data-testid="search-input"
        />
        {localValue && (
          <button
            onClick={handleClear}
            className="absolute right-4 top-1/2 -translate-y-1/2 w-6 h-6 rounded-full bg-slate-100 hover:bg-slate-200 flex items-center justify-center transition-colors"
            data-testid="search-clear-btn"
          >
            <X className="w-4 h-4 text-slate-500" />
          </button>
        )}
      </div>

      <Select value={sortBy} onValueChange={onSortChange}>
        <SelectTrigger 
          className="w-full sm:w-48 h-12 rounded-xl border-slate-200 bg-white"
          data-testid="sort-select"
        >
          <SelectValue placeholder="Sort by" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="newest">Newest First</SelectItem>
          <SelectItem value="alphabetical">Alphabetical</SelectItem>
          <SelectItem value="industry">By Industry</SelectItem>
          <SelectItem value="product">By Product</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default SearchBar;
